"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Progress = exports.PROGRESS_SIZES = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var hooks_1 = require("../../../mantine-hooks/src");
var theme_1 = require("../../../mantine-theme/src");
var Progress_styles_1 = __importStar(require("./Progress.styles"));
exports.PROGRESS_SIZES = Progress_styles_1.sizes;
function Progress(_a) {
    var className = _a.className, value = _a.value, color = _a.color, _b = _a.size, size = _b === void 0 ? 'md' : _b, _c = _a.radius, radius = _c === void 0 ? 'sm' : _c, _d = _a.striped, striped = _d === void 0 ? false : _d, themeOverride = _a.themeOverride, ariaLabel = _a["aria-label"], others = __rest(_a, ["className", "value", "color", "size", "radius", "striped", "themeOverride", 'aria-label']);
    var classes = Progress_styles_1.default({
        color: color,
        size: size,
        radius: radius,
        striped: striped,
        reduceMotion: hooks_1.useReducedMotion(),
        theme: theme_1.useMantineTheme(themeOverride),
    });
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.progress, className) }, others),
        react_1.default.createElement("div", { role: "progressbar", "aria-valuemax": 100, "aria-valuemin": 0, "aria-valuenow": value, "aria-label": ariaLabel, className: classes.bar, style: { width: value + "%" } })));
}
exports.Progress = Progress;
Progress.displayName = '@mantine/core/Progress';
